module.exports = __webpack_public_path__ + "img/mobile-banner1-tw.1f9e6c7d.jpg";